import { CodeChallenge, DataAccessCallbackService } from '@unico-people/shared/dashboard/data-access-callback';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { environment } from '@unico-people/shared/utils/environments';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { clearStorage, getTokenStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private identity_url: string = environment.identity_url;
  private url: string = environment.url_admission_api;
  private base_url = '';
  route = this.activatedRoute?.snapshot?.data?.roles;

  constructor(
    public jwtHelper: JwtHelperService,
    private http: HttpClient,
    private callbackService: DataAccessCallbackService,
    private launchdarklyService: LaunchdarklyService,
    private activatedRoute: ActivatedRoute
  ) {}

  loggedIn(): boolean {
    const token: string = getTokenStorage();
    return token != null && !this.jwtHelper.isTokenExpired(token);
  }

  logoutApi(): Observable<any> {
    return this.http.get<any>(`${this.url}/logout`);
  }

  logout(route: string): void {
    switch (route) {
      case 'ongoing':
        this.base_url = environment.ongoing_url;
        break;
      case 'benefits':
        this.base_url = environment.url_benefits;
        break;
      default:
        this.base_url = environment.admission_url;
        break;
    }

    this.logoutApi().subscribe(() => {
      clearStorage();
      window.location.href = `${this.identity_url}/signout?redirect_uri=${this.base_url}`;
    })
  }

  async startPKCEAuthenticationFlow(redirect_uri: string): Promise<string> {
    let match = this.launchdarklyService?.evaluateBoolean({flagKey: "people_authorization_code_with_pkce"});
    let identityFinalURL = `${this.identity_url}/oauth2/authorize?scope=*&redirect_uri=${redirect_uri}&response_type=code&client_id=8aead3e6-b295-4f77-b314-86b975ee3ae2`

    if (match) {
        const codeChallenge = await this.callbackService.getCodeChallenge().toPromise().catch((err) => {
          console.error(err)
          return {} as CodeChallenge
        })
        if (codeChallenge.raw && codeChallenge.method) {
          let pkceQueryParams = `&code_challenge=${codeChallenge.raw}&code_challenge_method=${codeChallenge.method}`
          identityFinalURL = `${identityFinalURL}${pkceQueryParams}`
        }
    }
    return identityFinalURL
  }
}
